import styled from "styled-components";
import { space } from "styled-system";

export const Svg = styled.svg`
  filter: drop-shadow(0 1px 3px rgba(17, 43, 68, 0.12));
  ${space}
`;
